/**
 * LDM · Barra de compra persistente
 * ---------------------------------------------------------------------------
 * Visible solo cuando el panel de compra ya pasó por encima de la pantalla.
 *
 * El control de cantidad no lleva un contador propio: pulsa el tier que
 * corresponde en el panel de arriba. Así el precio, el tachado, el regalo y la
 * cantidad que se enviará al carrito salen siempre de la misma fuente, y no hay
 * dos estados que puedan desincronizarse.
 */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-ldm-sticky]');
    if (!bar || bar.dataset.ldmInit === 'true') return;
    bar.dataset.ldmInit = 'true';

    var labelEl = bar.querySelector('[data-ldm-sticky-label]');
    var priceEl = bar.querySelector('[data-ldm-sticky-price]');
    var wasEl = bar.querySelector('[data-ldm-sticky-was]');
    var qtyEl = bar.querySelector('[data-ldm-sticky-qty]');
    var cta = bar.querySelector('[data-ldm-sticky-cta]');
    var offer = document.querySelector('[data-ldm-quantity-offer]');

    function tiers() {
      return offer
        ? Array.prototype.slice.call(offer.querySelectorAll('[data-ldm-tier]'))
        : [];
    }

    function indiceActual() {
      var t = tiers();
      for (var i = 0; i < t.length; i++) {
        if (t[i].classList.contains('is-selected')) return i;
      }
      return 0;
    }

    /* Vuelca el tier activo sobre la barra: cantidad, precio y tachado. */
    function sincronizar(detalle) {
      var sel = offer && offer.querySelector('[data-ldm-tier].is-selected');
      var d = detalle || {};

      // Sin evento (carga inicial) los valores se leen del tier ya marcado, para
      // que la barra no nazca mostrando el precio suelto del producto mientras
      // arriba hay otro tier seleccionado.
      if (!detalle && sel) {
        d = {
          price: sel.dataset.priceDisplay,
          label: sel.dataset.bundleLabel,
          quantity: parseInt(sel.dataset.qty, 10)
        };
      }

      if (priceEl && d.price) priceEl.textContent = d.price;
      if (labelEl && d.label) labelEl.textContent = d.label;
      if (qtyEl && d.quantity) qtyEl.textContent = d.quantity;

      if (wasEl) {
        var was = sel ? sel.querySelector('.ldm-qo__price-was') : null;
        var txt = was ? was.textContent.trim() : '';
        wasEl.textContent = txt;
        wasEl.hidden = !txt;
      }

      actualizarTopes();
    }

    document.addEventListener('ldm:tier-change', function (e) {
      sincronizar(e.detail);
    });

    /* Los botones se apagan en los extremos en vez de no hacer nada al pulsar. */
    function actualizarTopes() {
      var t = tiers();
      if (!t.length) return;
      var i = indiceActual();
      bar.querySelectorAll('[data-ldm-step]').forEach(function (b) {
        var paso = parseInt(b.dataset.ldmStep, 10);
        var destino = i + paso;
        b.disabled = destino < 0 || destino > t.length - 1;
      });
    }

    bar.querySelectorAll('[data-ldm-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = tiers();
        if (!t.length) return;
        var destino = indiceActual() + parseInt(b.dataset.ldmStep, 10);
        if (destino < 0 || destino > t.length - 1) return;

        // Se marca el radio del tier: dispara el mismo flujo que un clic en el
        // panel, así que precio, regalo y cantidad quedan sincronizados solos.
        var radio = t[destino].querySelector('.ldm-qo__radio-native');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    if (cta) {
      cta.addEventListener('click', function () {
        var target = offer || document.querySelector('form[action*="/cart/add"]');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = target.querySelector('[data-ldm-tier].is-selected') ||
                    target.querySelector('[data-ldm-tier]');
        if (first) {
          first.classList.add('ldm-pulse');
          setTimeout(function () {
            first.classList.remove('ldm-pulse');
          }, 1200);
        }
      });
    }

    if (!offer) {
      bar.hidden = false;
      return;
    }

    /* Visible solo cuando el panel de compra ya salió por arriba. */
    var visible = null;
    function actualizar() {
      var yaPaso = offer.getBoundingClientRect().bottom < 0;
      if (yaPaso !== visible) {
        visible = yaPaso;
        bar.hidden = !yaPaso;
      }
    }

    var pendiente = false;
    function alHacerScroll() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () {
        actualizar();
        pendiente = false;
      });
    }

    window.addEventListener('scroll', alHacerScroll, { passive: true });
    window.addEventListener('resize', alHacerScroll, { passive: true });
    actualizar();
    sincronizar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
